import React from 'react'
import { Column } from '../../entities/column/Column'
import Header from '../header/Header'
import MainContent from '../main-content/MainContent'
import OrdersColumns from '../orders-columns/OrdersColumns'
import OrdersSelector from '../orders-selector/OrdersSelectorContainer'
import Notification from '../notification/NotificationContainer'
import ConfirmAcceptDeclinedProduct from '../confirm-accept-declined-product/ConfirmAcceptDeclinedProductContainer'

export interface IOwnProps {
}

export interface IStateProps {
  columns: Column[]
  isLogged: boolean
  className?: string
}

export interface IDispatchProps {}

export type IProps = IOwnProps & IStateProps & IDispatchProps

const Dashboard: React.FC<IProps> = (props) => {
  const {
    columns,
    isLogged,
    className,
  } = props

  if (!isLogged) {
    return null
  }

  return (
    <div className={className}>
      <Header>
        <OrdersSelector />
      </Header>
      <Notification />

      <MainContent>
        <OrdersColumns
          columns={columns}
        />
      </MainContent>

      <ConfirmAcceptDeclinedProduct />
    </div>
  )
}

export default Dashboard
